import React from 'react';
import styled from 'styled-components';

export const InstructionForVariables: React.FC<{onSelect: (value: string) => () => void}> = ({onSelect}) => {
  return (
    <InstructionsWrapper>
      <Title>Add dynamic values:</Title>
      <InstructionText>Click on the option below or type it to add it to your message.</InstructionText>
      <VariableItem onClick={onSelect('{{first_name}}')}>
        <VariableButton>{'{{first_name}}'}</VariableButton>
        <VariableDescription>First name of the customer</VariableDescription>
      </VariableItem>
      <VariableItem onClick={onSelect('{{self_serve_link}}')}>
        <VariableButton>{'{{self_serve_link}}'}</VariableButton>
        <VariableDescription>Link to access My Account</VariableDescription>
      </VariableItem>
      <VariableItem onClick={onSelect('{{waiver_link}}')}>
        <VariableButton>{'{{waiver_link}}'}</VariableButton>
        <VariableDescription>Link to access Manage Waivers</VariableDescription>
      </VariableItem>
      <VariableItem onClick={onSelect('{{ticket_link}}')}>
        <VariableButton>{'{{ticket_link}}'}</VariableButton>
        <VariableDescription>Link to Order Confirmation with Tickets</VariableDescription>
      </VariableItem>
    </InstructionsWrapper>
  );
};

export const InstructionsWrapper = styled.div`
  margin-bottom: 45px;
`;

export const Title = styled.div`
  font-weight: bold;
`;

export const InstructionText = styled.div`
  margin-top: 8px;
  margin-bottom: 8px;
  font-size: 14px;
  color: #000;
`;

export const VariableItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  cursor: pointer;
`;

export const VariableButton = styled.div`
  background-color: #d9d9d9;
  border-radius: 4px;
  padding: 2px 6px;
  font-family: monospace;
  font-size: 12px;
  margin-right: 8px;
  color: #000;
  border: 1px solid #d9d9d9;
  min-width: 100px;
  text-align: center;
`;

export const VariableDescription = styled.span`
  color: #000;
  font-size: 14px;
`;
